import { Component, OnInit, signal, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet, Router } from '@angular/router';
import { LogoutModalComponent } from '../../../shared/components/logout-modal/logout-modal.component';
import { PlatformConfigService } from '../../services/platform-config.service';
import { AuthService } from '../../services/auth/auth.service';
import { Store } from '@ngrx/store';
import * as UserAuthActions from '../../../store/user/auth/user-auth.actions';
import * as AuthActions from '../../../store/auth/auth.actions';

@Component({
  selector: 'app-tc-layout',
  standalone: true,
  imports: [CommonModule, RouterOutlet, LogoutModalComponent],
  templateUrl: './tc-layout.component.html',
  styleUrl: './tc-layout.component.css',
})
export class TcLayout implements OnInit {
  logoutModalVisible = signal<boolean>(false);
  private store = inject(Store);
  private authService = inject(AuthService);

  constructor(
    public platformConfigService: PlatformConfigService,
    private router: Router
  ) {}

  ngOnInit() {
    // Ensure user details are loaded
    this.store.dispatch(UserAuthActions.loadUserDetails());
  }

  onLogout(): void {
    this.logoutModalVisible.set(true);
  }

  confirmLogout(): void {
    this.logoutModalVisible.set(false);
    this.store.dispatch(AuthActions.logout());
  }

  cancelLogout(): void {
    this.logoutModalVisible.set(false);
  }
}
